import { Flex, IconFont, Text } from '@byecode/ui'
import { type OtherPlatformType, useAtomData } from '@lighthouse/shared'
import React, { useMemo } from 'react'
import styled from 'styled-components'

import { otherPlatformListAtom } from '@/atoms/application/state'
import { otherPlatformNameMap } from '@/containers/OtherPlatforms/constant'
import { openOtherPlatform } from '@/containers/OtherPlatforms/OtherPlatformEvent'

interface IntegratedCardProps {
    type: OtherPlatformType
}

const SCxContainer = styled(Flex)`
    display: flex;
    align-items: center;
    height: 38px;
    gap: 4px;
    padding: 0 8px;
    background-color: var(--color-gray-100);
    border-radius: 6px;
    font-size: var(--font-size-normal);
    cursor: pointer;
`
export const IntegratedCard: React.FunctionComponent<IntegratedCardProps> = ({ type }) => {
    const otherPlatforms = useAtomData(otherPlatformListAtom)

    const account = useMemo(() => otherPlatforms?.find(item => item.type === type), [otherPlatforms, type])

    const merchantAccounts = otherPlatforms?.filter(item => item.type === 'WECHAT_PAY') ?? []
    const isPerfected = type === 'WECHAT_PAY' ? merchantAccounts.some(item => item.configurationComplete) : account?.configurationComplete

    return (
        <SCxContainer
            justifyContent="space-between"
            onClick={() => {
                openOtherPlatform({ type })
            }}
        >
            <Flex gap={4} alignItems="center">
                <IconFont color={isPerfected ? 'var(--color-green-500)' : 'var(--color-gray-400)'} size={16} type="TickCircle" />
                <Text color="var(--color-black)">{otherPlatformNameMap[type]}</Text>
            </Flex>
            <Flex justifyContent="flex-end">
                <Text color="var(--color-gray-400)">
                    {type === 'WECHAT_PAY' ? `${merchantAccounts.length} 个商户 · 管理` : isPerfected ? '已完善' : '需完善配置授权'}
                </Text>
                <IconFont color="var(--color-gray-400)" size={16} type="ArrowRightSmall" />
            </Flex>
        </SCxContainer>
    )
}
